import { action } from 'satcheljs';
export default action('CHECK_MAILBOX_EXPORT_STATUS');
//# sourceMappingURL=checkMailboxExportStatus.js.map